// extracted by mini-css-extract-plugin
export default {"gradeScaleBlock":"gradeScaleBlock-wmP66","gradeScaleLegend":"gradeScaleLegend-uYehi","legendBlock":"legendBlock-qXKgd"};